import { NewsAndPromotionTable } from './NewsAndPromotionTable'
import { withNewsAndPromotionTable } from './withNewsAndPromotionTable'

const ConnectedNewsAndPromotionTable = withNewsAndPromotionTable(
  NewsAndPromotionTable
)
export { ConnectedNewsAndPromotionTable as NewsAndPromotionTable }
